import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Accordion } from "react-bootstrap";

interface Props {
  fieldName: string;
  id?: string;
}

const HelpTextAccordion: React.FC<Props> = ({ fieldName, id }) => {
  const { t } = useTranslation();
  const key = fieldName + ".help";
  const titleKey = key + ".title";
  const textKey = key + ".text";
  const hasText = t(textKey) !== textKey;
  const hasTitle = t(titleKey) !== titleKey;
  const helpTextId = id || `${fieldName}-help`;

  const helpText = {
    title: hasTitle
      ? t(titleKey)
      : t(`${fieldName}.title`) !== `${fieldName}.title`
        ? t(`${fieldName}.title`)
        : t(`${fieldName}.label`) !== `${fieldName}.label`
          ? t(`${fieldName}.label`)
          : "",
    text: hasText ? t(textKey) : "",
  };

  if (!hasText) {
    return null;
  }

  return (
    <div id={helpTextId}>
      <Accordion className="help-text-container">
        <Accordion.Item eventKey="0">
          <Accordion.Header as="h3">{helpText.title}</Accordion.Header>
          <Accordion.Body className="mt-2">
            <Trans
              i18nKey={helpText.text}
              components={{
                ul: <ul></ul>,
                li: <li></li>,
                Link1: (
                  <a href={t(`${key}.url1`)} target={"_blank"}>
                    https://example.com/1
                  </a>
                ),
                Link2: (
                  <a href={t(`${key}.url2`)} target={"_blank"}>
                    https://example.com/2
                  </a>
                ),
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default HelpTextAccordion;
